import * as React from "react";
import { connect } from "react-redux";
import { Button } from "@mantine/core";
import { bindActionCreators } from "redux";
import { updateAppointmentStatus } from "../../data/actions/appointmentActions";
import { AppointmentStatus } from "../../types/appointments/AppointmentStatus";
import { CenteredLoader } from "../common/loader";

interface IRejectAppointmentProps {
  appointment: string;
  actions: {
    updateAppointmentStatus: (
      appointment: string,
      status: AppointmentStatus,
      comment: string,
    ) => Promise<any>;
  };
  onClose: Function;
  onSave: Function;
}

const RejectAppointment: React.FunctionComponent<IRejectAppointmentProps> = ({
  appointment,
  actions,
  onClose,
  onSave,
}) => {
  const [comment, updateComment] = React.useState("");
  const [saving, changeSavingStatus] = React.useState(false);
  const [error, updateError] = React.useState(null);

  const save = () => {
    changeSavingStatus(true);
    actions
      .updateAppointmentStatus(appointment, AppointmentStatus.rejected, comment)
      .then((apt) => {
        changeSavingStatus(false);
        onSave();
        onClose();
      })
      .catch((er) => {
        changeSavingStatus(false);
        const message = er.toString() || er.message;
        updateError(message);
      });
  };

  return (
    <>
      <textarea
        value={comment}
        onChange={(e) => updateComment(e.currentTarget.value)}
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "5px",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        }}
        placeholder="Why do you want to reject this appointment"
      />
      {saving && <CenteredLoader />}
      {error && <p color="red">{error}</p>}
      <br />
      <br />
      <Button
        onClick={() => onClose()}
        style={{ marginLeft: "0px", marginRight: "auto" }}
      >
        Cancel
      </Button>
      <Button
        onClick={save}
        color="blue"
        style={{ position: "absolute", right: "15px" }}
        disabled={saving}
      >
        Reject
      </Button>
    </>
  );
};

const mapState2Props = (state, props: IRejectAppointmentProps) => ({});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ updateAppointmentStatus }, dispatch),
  };
}

export default connect(mapState2Props, mapDispatchToProps)(RejectAppointment);
